import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntGroupExpRoutingModule } from './int-group-exp-routing.module';
import { NgbDatepickerModule, NgbDropdownModule, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { BreadcrumbModule, ModalModule } from 'src/app/theme/shared/components';
import { IntGroupExpComponent } from './int-group-exp.component';
import { SortablejsModule } from 'ngx-sortablejs';
import { InteractionListItemModule } from 'src/app/components/interactions/interaction-list-item/interaction-list-item.module';
import { ArchwizardModule } from 'angular-archwizard';
import { ColorPickerModule } from 'ngx-color-picker';
import { MediaManagerModule } from 'src/app/components/media-manager/media-manager.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageMapComponent } from 'src/app/components/image-map/image-map.component';
import { SelectModule } from 'ng-select';
import { TinymceModule } from 'angular2-tinymce';
import {SearchPipe} from './search.pipe';


@NgModule({
  declarations: [IntGroupExpComponent, ImageMapComponent, SearchPipe],
  imports: [
    CommonModule,
    IntGroupExpRoutingModule,
    SharedModule,
    SortablejsModule,
    NgbDropdownModule,
    InteractionListItemModule,
    ReactiveFormsModule,
    ArchwizardModule,
    ColorPickerModule,
    MediaManagerModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    SelectModule,
    TinymceModule.withConfig({
      remove_trailing_brs: true,
      remove_linebreaks: true,
      indent: false,
      branding: false,
      auto_focus: false,
      plugins: 'link table paste',
      contextmenu: 'link table'
    }),
  ]
})
export class IntGroupExpModule { }
